import { Component, OnInit, Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ShoppingCartModel } from '@core/model/shoppingCart.model';
import { ItemService } from '@shared/service/items.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
   
@Injectable({providedIn: 'root'})

@Component({
  selector: 'app-modal-download-quote',
  templateUrl: './modal-download-quote.component.html',
  styleUrls: ['./modal-download-quote.component.scss']
})
export class ModalDownloadQuoteComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  private ShoppingCartId: number = 0;
  constructor(
    public dialogRef: MatDialogRef<ModalDownloadQuoteComponent>,
    private itemService: ItemService,
    @Inject(MAT_DIALOG_DATA) public dataMessage: any,
  ) {
    if (this.dataMessage !== null && this.dataMessage !== undefined) {
      this.ShoppingCartId = this.dataMessage.ShoppingCartId;
    }
  }

  ngOnInit(): void {
    this.downloadExcel();
  }
  
  downloadExcel() {
    let model = new ShoppingCartModel(0, '', '', '', '', '');
    model.Id = this.ShoppingCartId;
    this.itemService.downloadShoppingCart(model);
    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
